import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * ヒーローの表示状態を監視し、body.is-past-hero を一元管理する
 * 他機能でも再利用できるよう、状態変化時にイベントも発火する
 */

export const HERO_PAST_STATE_EVENT = "hero:past-state-change";

export function initHeroPastState(options = {}) {
  const {
    heroId = "hero",
    bodyClassName = "is-past-hero",
    leaveOffsetPx = 0,
    returnOffsetPx = 24,
  } = options;

  const heroSection = document.getElementById(heroId);
  const body = document.body;

  if (!heroSection) {
    console.warn("Required elements not found: hero section");
    return;
  }

  let isPastHero = body.classList.contains(bodyClassName);
  let leaveTrigger = null;
  let returnTrigger = null;

  function applyState(nextState) {
    if (nextState === isPastHero) return;

    isPastHero = nextState;
    body.classList.toggle(bodyClassName, isPastHero);
    window.dispatchEvent(
      new CustomEvent(HERO_PAST_STATE_EVENT, {
        detail: { isPastHero },
      })
    );
  }

  function syncInitialState() {
    const heroRect = heroSection.getBoundingClientRect();

    applyState(heroRect.bottom <= leaveOffsetPx);
  }

  function createTrigger() {
    if (leaveTrigger) {
      leaveTrigger.kill();
      leaveTrigger = null;
    }

    if (returnTrigger) {
      returnTrigger.kill();
      returnTrigger = null;
    }

    // ヒーロー下端がビューポート上端 + leaveOffsetPx を越えたら past 状態にする
    leaveTrigger = ScrollTrigger.create({
      trigger: heroSection,
      start: () => `bottom top+=${leaveOffsetPx}`,
      onEnter: function() {
        applyState(true);
      },
      onRefresh: function() {
        syncInitialState();
      },
    });

    // 既にpast状態なら、ヒーロー下端がビューポート上端 + returnOffsetPx より下へ戻った時に解除
    returnTrigger = ScrollTrigger.create({
      trigger: heroSection,
      start: () => `bottom top+=${returnOffsetPx}`,
      onLeaveBack: function() {
        applyState(false);
      },
      onRefresh: function() {
        syncInitialState();
      },
    });

    requestAnimationFrame(function() {
      syncInitialState();
    });
  }

  window.addEventListener("resize", createTrigger);

  // 初期状態を同期
  createTrigger();
}
